import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { CommonConfig } from '../../../configs/config.common';
import { isHasImg } from '../../../utils/assist';

@Component({
   components: {
   }
})
export default class PropertyPicBanner extends Vue {
   public title: string = 'PropertyPicBanner';

   public configs = new CommonConfig();

   @Prop()
   public data: any;

   @Prop()
   public virtualTourLink!: string;

   @Watch('data', { immediate: true, deep: true })
   public async onDataInput(val: any, oldVal: any) {
      const newData: any[] = [];
      val.map(async (v: any) => {
         const has = await isHasImg(v);
         if (has) {
            newData.push(v);
         }
      });
      this.displayData = newData;
   }

   public displayData: any = [
      isHasImg('www.baidu.com') ? 'www.baidu.com' : this.configs.housePicPlaceHolder
   ];
}
